import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {LevelHistory} from "../../model/level/level-history.model";
import {LevelDefinition} from "../../model/level/level-definition.model";
import {BadgeHistory} from "../../model/badge/badge-history.model";
import {CampaignServiceProvider} from "../../../ranking/services/campaign-service/campaign-service";
import {ConfigServiceProvider} from "../../../core/services/config-service/config-service";
import {StorageServiceProvider} from "../../../core/services/storage-service/storage-service";
import {DisplayServiceProvider} from "../../../core/services/display-service/display-service";
import {BadgeDefinition} from "../../model/badge/badge-definition.model";

@Injectable()
export class AchievementsServiceProvider {
  levelsHistory: LevelHistory[] = [];
  levelsDefinitions: LevelDefinition[] = [];
  badgesDefinitions: BadgeDefinition[] = [];
  badgesHistory: BadgeHistory[] = [];
  badgeProgress = [];

  constructor(
    private campaignService: CampaignServiceProvider,
    private configService: ConfigServiceProvider,
    private http: HttpClient,
    private storageService: StorageServiceProvider,
    private displayService: DisplayServiceProvider
  ) {}

  getAchievedBadges() {
    let achievedBadges = [];

    for (let i = 0; i < this.badgesDefinitions.length; i++) {
      for (let j = 0; j < this.badgesHistory.length; j++) {
        if (this.badgesDefinitions[i].id === this.badgesHistory[j].badgeId) {
          achievedBadges.push(this.badgesHistory[j]);
          break;
        }
      }
    }

    return achievedBadges;
  }

  getAchievedLevels() {
    let userCampaigns = this.campaignService.getUserCampaigns();
    let currentLevels = [];

    if (userCampaigns && userCampaigns.length > 0 && this.levelsHistory && this.levelsHistory.length > 0) {
      for (let i = 0; i < userCampaigns.length; i++) {
        for (let j = 0; j < this.levelsHistory.length; j++) {
          if (this.levelsHistory[j].params.campaign && userCampaigns[i] === this.levelsHistory[j].params.campaign) {
            let level = this.getLevelById(this.levelsHistory[j].currentLevelId);

            if (level) {
              currentLevels.push(level);
            }
            break;
          }
        }
      }
    }

    return currentLevels;
  }

  getNewBadges(currentBadges, savedBadges) {
    let newBadges = [];

    for (let i = 0; i < currentBadges.length; i++) {
      for (let j = 0; j < savedBadges.length; j++) {
        if (currentBadges[i].badgeId === savedBadges[j].badgeId) {
          if (currentBadges[i].badgeLevel > savedBadges[j].badgeLevel) {
            newBadges.push(currentBadges[i]);
          }
          break;
        }
        else if (j === savedBadges.length - 1) {
          newBadges.push(currentBadges[i]);
        }
      }
    }

    return newBadges;
  }

  getNewLevels(currentLevels, savedLevels) {
    let newLevels = [];

    for (let i = 0; i < currentLevels.length; i++) {
      for (let j = 0; j < savedLevels.length; j++) {
        if (currentLevels[i].params.campaign === savedLevels[j].params.campaign) {
          if (currentLevels[i].level > savedLevels[j].level) {
            newLevels.push(currentLevels[i]);
          }
          break;
        }
        else if (j === savedLevels.length - 1) {
          newLevels.push(currentLevels[i]);
        }
      }
    }

    return newLevels;
  }

  getLevelById(levelId) {
    for (let i = 0; i < this.levelsDefinitions.length; i++) {
      if (this.levelsDefinitions[i].id === levelId) {
        return this.levelsDefinitions[i];
      }
    }
  }

  static sortByDate(a, b) {
    return Number(new Date(b.date)) - Number(new Date(a.date));
  }

  load() {
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getUrl('achievements'))
        .toPromise()
        .then((response: any) => {
          let badgesDefs = response.badgeDefinitions;
          let badgesDefsMap = {};

          for (let i = 0; i < badgesDefs.length; i++) {
            badgesDefsMap[badgesDefs[i].id] = badgesDefs[i];
          }

          Promise.all([
            this.storageService.setObject('levelsDefinitions', response.levelDefinitions),
            this.storageService.setObject('badgesDefinitions', badgesDefsMap),
            this.storageService.setObject('levelsHistory', response.levelHistory),
            this.storageService.setObject('badgesHistory', response.badgeHistories),
            this.storageService.setObject('experiencePoints', response.experiencePoints),
            this.storageService.setObject('badgeProgress', response.badgeProgress || []),
          ])
            .then(() => {
              this.levelsHistory = response.levelHistory.sort(AchievementsServiceProvider.sortByDate);
              this.levelsDefinitions = response.levelDefinitions;
              this.badgesDefinitions = response.badgeDefinitions;
              this.badgesHistory = response.badgeHistories.sort(AchievementsServiceProvider.sortByDate);
              this.badgeProgress = response.badgeProgress;
              return this.findNewBadges();
            })
            .then(() => resolve())
            .catch((error) => reject(error));
        })
        .catch((error) => reject(error))
    })
  }


  getLevelsDef() {
    return this.storageService.getObject('levelsDefinitions');
  }


  getBadgesDef() {
    return this.storageService.getObject('badgesDefinitions');
  }


  getBadgesHistory() {
    return this.storageService.getObject('badgesHistory');
  }

  getLevelsHistory() {
    return this.storageService.getObject('levelsHistory');
  }

  getExpPoints() {
    return this.storageService.getObject('experiencePoints');
  }

  getCurrentBadges() {
    return this.storageService.getObject('currentBadges');
  }

  getProgressForBadge(id) {
    return this.storageService.getObject('badgeProgress')
      .then((badges: Array<any>) => {
          for (let i = 0; i < badges.length; i++) {
            let badge = badges[i];
            if (id === '' + badge.badgeId) {
              return badge;
            }
          }
          return null;
        }
      );
  }

  setCurrentBadges(currentBadges) {
    return new Promise((resolve, reject) => {
      this.storageService.setObject('currentBadges', currentBadges)
        .then(() => resolve())
        .catch((error) => reject(error))
    })
  }


  getCurrentLevels() {
    return this.storageService.getObject('currentLevels');
  }


  setCurrentLevels(currentLevels) {
    return new Promise((resolve, reject) => {
      this.storageService.setObject('currentLevels', currentLevels)
        .then(() => resolve())
        .catch((error) => reject(error))
    })
  }


  findNewLevels() {
    let achievedLevels = this.getAchievedLevels();
    return new Promise((resolve, reject) => {
      this.getCurrentLevels().then((response) => {
          if (response) {
            let newLevels = this.getNewLevels(achievedLevels, response);

            if (newLevels && newLevels.length > 0) {
              this.displayService.setNewLevels(newLevels);
            }
          }
        }
      ).then(() =>
        this.setCurrentLevels(achievedLevels)
          .then(() => resolve())
          .catch(e => reject(e))
          .catch(() => resolve()))
    })

  }

  findNewBadges() {
    let achievedBadges = this.getAchievedBadges();

    return new Promise((resolve, reject) => {
      this.getCurrentBadges()
        .then((response) => {
          if (response) {
            let newBadges = this.getNewBadges(achievedBadges, response);

            if (newBadges.length > 0) {
              this.displayService.setNewBadges(newBadges);
            }
          }
        })
        .then(() => this.setCurrentBadges(achievedBadges)
          .then(() => resolve())
          .catch(e => reject(e)))
        .catch(() => resolve())
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/achievement/services/achievements-service/achievements-service.ts